import Vue from 'vue'
import VueApollo from 'vue-apollo'
// import Cookies from "js-cookie";
// import URL from "./constants/uri.constants"
import { createApolloClient } from 'vue-cli-plugin-apollo/graphql-client'
// in vue-apollo.js
import { HttpLink } from 'apollo-link-http'
import { Message } from 'element-ui'
import { billingApiBase } from './api/billingBase'

// Install the vue plugin
Vue.use(VueApollo)

// Name of the localStorage item
// const AUTH_TOKEN = 'apollo-token'
// Http endpoint
const path = window.CONFIG.baseUrl // URL.baseUrl;
const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || path
const httpLink = new HttpLink({
  // uri: httpEndpoint,
  uri: `${billingApiBase()}/base/api/graphql`
})

// Files URL root
export const filesRoot = process.env.VUE_APP_FILES_ROOT || httpEndpoint.substr(0, httpEndpoint.indexOf('/graphql'))

Vue.prototype.$filesRoot = filesRoot

// Config
const defaultOptions = {
  // You can use `https` for secure connection (recommended in production)
  httpEndpoint,
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  // wsEndpoint: process.env.VUE_APP_GRAPHQL_WS || 'ws://localhost:4000/graphql',
  wsEndpoint: null,
  // LocalStorage token
  // tokenName: AUTH_TOKEN,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,

  // Override default apollo link
  // note: don't override httpLink here, specify httpLink options in the
  // httpLinkOptions property of defaultOptions.
  // link: myLink
  link: httpLink

  // Override default cache
  // cache: myCache

  // Override the way the Authorization header is set
  // getAuth: defaultGetAuth

  // Additional ApolloClient options
  // apollo: { ... }

  // Client local data (see apollo-link-state)
  // clientState: { resolvers: { ... }, defaults: { ... } }
}

// Call this in the Vue app file
export function createProvider (options = {}) {
  // Create apollo client

  const { apolloClient } = createApolloClient({
    ...defaultOptions,
    ...options
  })
  // apolloClient.wsClient = wsClient

  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        // fetchPolicy: 'cache-and-network',
      }
    },
    errorHandler (error) {
      // eslint-disable-next-line no-console
      // console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message)
      try {
        let mes = error.message.split('GraphQL error: ')[1]
        console.log(mes)
        Message.error(mes)
      } catch (err) {
        console.log(error.message)
      }
      return error
    }
  })

  return apolloProvider
}

// function defaultGetAuth (tokenName) {
//   console.log("tokenName --> ", tokenName, window)
//   if (typeof window !== 'undefined') {
//     // get the authentication token from local storage if it exists
//     const token = window.localStorage.getItem(tokenName)
//     // return the headers to the context so httpLink can read them
//     return token ? `Bearer ${token}` : ''
//   }
// }

// Manually call this when user log in
export async function onLogin () {

}

// Manually call this when user log out
export async function onLogout () {

}

export default createProvider()
